<template>
  <div class="guider-apply-container">
    <div class="pc">
      <hm-content title :hidden="hidden">
        <div class>
          <el-radio-group
            v-model="auditState"
            size="small"
            @change="switchTabs"
          >
            <el-radio-button label="all"
              >全部({{ result.totalNum }})</el-radio-button
            >
            <el-radio-button label="wait"
              >待审核({{ result.waitNum }})</el-radio-button
            >
            <el-radio-button label="agree"
              >同意({{ result.agreeNum }})</el-radio-button
            >
            <el-radio-button label="refuse"
              >驳回({{ result.refuseNum }})</el-radio-button
            >
          </el-radio-group>
          <div class="flex item-center flex-between">
            <div class="flex item-center" v-if="auditState === 'all'">
              <div
                @click="(openDownLoad) => (downloadVisible = true)"
                class="delete pointer"
              >
                <span class="delete-icon hmicon icon-daochu"></span>
                下载模板
              </div>
              <div
                @click="(openExport) => (exportVisible = true)"
                class="delete pointer"
              >
                <span class="delete-icon hmicon icon-daoru"></span>
                导入
              </div>
              <!-- <div class="delete ml20 pointer open-file">
                <span class="delete-icon hmicon icon-daoru"></span>
                导出
                <input
                    type="file"
                    @change="importf($event)"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </div> -->
              <!-- <div @click="outputExcel" class="delete pointer" v-if="auditState === 'all'">
                <span class="delete-icon hmicon icon-daochu"></span>
                导出模板
              </div>
              <div class="delete ml20 pointer open-file" v-if="auditState === 'all'">
                <span class="delete-icon hmicon icon-daoru"></span>
                导入月结数据
                <input
                    type="file"
                    @change="importf($event)"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </div>
              <div class="delete ml20 pointer open-file" v-if="auditState === 'all'">
                <span class="delete-icon hmicon icon-daoru"></span>
                导入手机号查询导购商户
                <input
                    type="file"
                    @change="importf($event, 'phone')"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </div>
              <div @click="outputShopTypeExcel" class="delete pointer" v-if="auditState === 'all'">
                <span class="delete-icon hmicon icon-daochu"></span>
                导出品牌店关联导购白名单模板
              </div>
              <div class="delete ml20 pointer open-file" v-if="auditState === 'all'">
                <span class="delete-icon hmicon icon-daoru"></span>
                导入品牌店关联导购白名单
                <input
                    type="file"
                    @change="importfShopTypeAboutGuide($event)"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </div> -->
            </div>
            <div class="table-panel flex flex-wrap mb20 mt20">
              <el-select
                :disabled="allMerchant.length === 0"
                style="width: 300px"
                size="small"
                clearable
                placeholder="请选择商户"
                v-model="searchCondition.storeCode"
                class="mr10"
                filterable
                remote
                :remote-method="remoteMethod"
              >
                <el-option
                  v-for="item in storeBasicList"
                  :key="item.storeCode"
                  :label="item.storeName"
                  :value="item.storeCode"
                ></el-option>
              </el-select>
              <el-date-picker
                :default-time="['00:00:00', '23:59:59']"
                v-model="searchCondition.applyDate"
                type="datetimerange"
                align="right"
                start-placeholder="申请开始日期"
                end-placeholder="申请结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
              ></el-date-picker>
              <el-input
                clearable
                v-model.trim="searchCondition.keyWord"
                placeholder="输入导购名称/电话"
                size="small"
                style="width: 222px"
                class="ipt mr10"
              ></el-input>
              <el-button type="primary" size="small" @click="search"
                >查询</el-button
              >
              <el-button type="success" size="small" @click="outputDetail"
                >生成报表</el-button
              >
              <el-button type="success" size="small" @click="outputDetail1"
                >生成切换门店明细</el-button
              >
            </div>
          </div>

          <div class="table">
            <el-table
              stripe
              border
              ref="brandTable"
              :data="list"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                :index="(index) => index + (currentPage - 1) * pageSize + 1"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="申请状态"
              >
                <template slot-scope="scope">
                  <span class="success" v-if="scope.row.auditState === 'agree'"
                    >同意</span
                  >
                  <span class="danger" v-if="scope.row.auditState === 'refuse'"
                    >拒绝</span
                  >
                  <span class="blue" v-if="scope.row.auditState === 'wait'"
                    >待审核</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="applyType"
                label="申请类型"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.applyType === 'reg'">导购注册</span>
                  <span v-if="scope.row.applyType === 'switch'">切换门店</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="guiderName"
                label="注册名"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="guiderPhone"
                label="绑定电话"
              ></el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="商户"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="shopName"
                label="门店"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptShopName"
                label="其他门店"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="declareTime"
                label="申请时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="lastAuditAgreeTime"
                label="变更门店时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="refuseReason"
                label="驳回原因"
                v-if="auditState !== 'agree'"
              >
                <template slot-scope="scope">
                  <div class="danger">
                    {{ scope.row.refuseReason }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="auditTime"
                label="审核时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="auditUsername"
                label="审核人"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="workCardImg"
                label="门头照片"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-image
                      v-if="scope.row.workCardImg"
                      style="width: 100px; height: 100px"
                      :src="scope.row.workCardImg"
                      :preview-src-list="[scope.row.workCardImg]"
                    >
                    </el-image>
                    <span v-else>未上传图片</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="outletImg"
                label="小票照片"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-image
                      v-if="scope.row.outletImg"
                      style="width: 100px; height: 100px"
                      :src="scope.row.outletImg"
                      :preview-src-list="[scope.row.outletImg]"
                    >
                    </el-image>
                    <span v-else>未上传图片</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="monthlyStatementFlag"
                label="月结权限"
                v-if="auditState === 'all'"
              >
                <template slot-scope="scope">
                  <el-switch
                    @change="changeMonthlyStatementFlag(scope.row)"
                    v-model="scope.row.monthlyStatementFlag"
                    active-color="#13ce66"
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                prop="changeGuiderState"
                label="申报权限"
              >
                <template slot-scope="scope">
                  <el-switch
                    @change="changeGuiderState(scope.row)"
                    v-model="scope.row.isAllowDeclare === '0'"
                    active-color="#13ce66"
                  >
                  </el-switch>
                </template>
              </el-table-column> -->
              <!-- 已审核已驳回不显示 -->
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="操作"
                width="240"
                v-show="auditState === 'wait' || auditState === 'all'"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button
                      size="small"
                      type="text"
                      @click="changeIDCardRecord(scope.row)"
                      >实名记录</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      @click="changeRecord(scope.row)"
                      >变更记录</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      @click="changeBlackWhiteRecord(scope.row)"
                      >黑白名单记录</el-button
                    >
                  </div>
                  <div class="flex flex-center">
                    <el-button
                      size="small"
                      type="text"
                      @click="updateShop(scope.row)"
                      v-if="scope.row.auditState === 'wait'"
                      >修改门店</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      @click="audit(scope.row)"
                      v-if="scope.row.auditState === 'wait'"
                      >同意</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      @click="reject(scope.row)"
                      v-if="scope.row.auditState === 'wait'"
                      >拒绝</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      @click="changeDeclareRecord(scope.row)"
                      >申报权限变更明细</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      @click="loginRecord(scope.row)"
                      >登陆记录</el-button
                    >
                  </div>
                  <div class="flex flex-center">
                      <el-button
                      size="small"
                      type="text"
                      @click="changeGuiderState(scope.row)"
                      >申报与提现权限管理</el-button
                    >
                  </div>
                  <div class="flex flex-center">
                      <el-button
                      size="small"
                      type="text"
                      @click="signatureList(scope.row)"
                      >签名列表</el-button
                    >
                  </div>
                  <div class="flex flex-center">
                      <el-button
                      size="small"
                      type="text"
                      @click="changeRecords(scope.row)"
                      >查看非自动加入品牌变更记录</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="total"
                @current-change="paging"
                @size-change="handleSizeChange"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPage"
              ></el-pagination>
            </div>
          </div>
        </div>

        <el-dialog
          title="驳回备注"
          :visible="detailsVisible"
          @close="detailsVisible = false"
          custom-class="sales-volumn-dialog"
        >
          <el-form
            label-width="80px"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
          >
            <el-form-item label="驳回原因" prop="refuseReason">
              <el-input
                maxlength="100"
                placeholder="请输入驳回原因，可直接选择下方模板"
                size="small"
                style="width: auto"
                :autosize="{ minRows: 4 }"
                type="textarea"
                v-model="ruleForm.refuseReason"
              ></el-input>
            </el-form-item>
            <div class="reject-refuseReason">
              <el-radio-group
                v-model="rejectReason"
                @change="switchRejectReason"
              >
                <div v-for="(v, i) in rejectTemp" :key="i">
                  <el-radio :label="i">{{ v }}</el-radio>
                </div>
              </el-radio-group>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer flex flex-center">
            <el-button
              @click="submitReject('ruleForm')"
              size="small"
              type="primary"
              >确认</el-button
            >
            <el-button @click="detailsVisible = false" size="small"
              >关闭</el-button
            >
          </span>
        </el-dialog>
        <el-dialog
          title="修改门店"
          :visible="detailsShop"
          @close="detailsShop = false"
          custom-class="sales-volumn-dialog"
        >
          <el-form
            label-width="100px"
            :model="ruleFormShop"
            :rules="rulesShop"
            ref="ruleFormShop"
          >
            <el-form-item label="选择商户" prop="storeCode">
              <el-select
                :disabled="allMerchant.length === 0"
                style="width: 300px"
                size="small"
                clearable
                placeholder="请选择商户"
                v-model="ruleFormShop.storeCode"
                class="mr10"
                filterable
                remote
                :remote-method="remoteMethod"
                @change="queryShop"
              >
                <el-option
                  v-for="item in storeBasicList"
                  :key="item.storeCode"
                  :label="item.storeName"
                  :value="item.storeCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择门店" prop="shopId">
              <el-select
                class="mr10"
                size="small"
                filterable
                :disabled="shopList.length === 0"
                v-model="ruleFormShop.shopId"
                placeholder="请选择门店"
              >
                <el-option
                  :label="v.shopName"
                  :value="v.shopId"
                  v-for="(v, i) in shopList"
                  :key="i"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer flex flex-center">
            <el-button
              @click="editShop('ruleFormShop')"
              size="small"
              type="primary"
              >确认</el-button
            >
            <el-button @click="detailsShop = false" size="small"
              >关闭</el-button
            >
          </span>
        </el-dialog>
         <el-dialog
          title="选择供应商品牌"
          :visible="supplierBrand"
          @close="supplierBrand = false"
          width="500px"
          custom-class="sales-volumn-dialog"
        >
          <div class="mb20" v-for="item in supplierBrandList" :key="item.supplierCode">
            <div class="flex item-center flex-between">
                  <el-checkbox v-model="item.checked">
                    <span style="fontWeight: bold;">{{item.supplierName}}</span>
                  </el-checkbox>
                    <i :class="item.checked?'el-icon-arrow-down':'el-icon-arrow-right'"></i>
            </div>
            <div class="ml20" v-if="item.checked">
               <div class="mt10" v-for="(info,index) in item.brandInfoList" :key="index">
                  {{info.brandName}}
              </div>
            </div>
          </div>
          <div style="width: 100px;margin: 20px auto;text-align: center;" v-if="supplierBrandList.length == 0">暂无数据</div>

          <span slot="footer" class="dialog-footer flex item-center flex-between">
            <div>
              已选择{{checkedSupplierBrandAll.length}}个品牌
            </div>
            <div>
                <el-button
                @click="affirmSupplierBrand"
                size="small"
                type="primary"
                >确认</el-button
              >
              <el-button @click="supplierBrand = false" size="small"
                >关闭</el-button
              >
            </div>
            
          </span>
        </el-dialog>
        <el-dialog
          title="变更记录"
          :visible="changeShopVisible"
          @close="changeShopVisible = false"
          custom-class="sales-volumn-dialog"
          width="1200px"
        >
          <div>
            <el-table
              stripe
              border
              :data="changeShopList"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                :index="
                  (index) => index + (currentPageShop - 1) * pageSizeShop + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="申请状态"
              >
                <template slot-scope="scope">
                  <span class="success" v-if="scope.row.auditState === 'agree'"
                    >同意</span
                  >
                  <span class="danger" v-if="scope.row.auditState === 'refuse'"
                    >拒绝</span
                  >
                  <span class="blue" v-if="scope.row.auditState === 'wait'"
                    >待审核</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="applyType"
                label="申请类型"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.applyType === 'reg'">导购注册</span>
                  <span v-if="scope.row.applyType === 'switch'">切换门店</span>
                  <span v-if="scope.row.applyType === 'delShop'">删除门店</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="guiderName"
                label="注册名"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="guiderPhone"
                label="绑定电话"
              ></el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="商户"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="shopName"
                label="门店"
              ></el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                prop="receiptShopName"
                label="其他门店"
              ></el-table-column> -->
              <el-table-column
                header-align="center"
                align="center"
                prop="declareTime"
                label="申请时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="refuseReason"
                label="驳回原因"
                v-if="auditState !== 'agree'"
              >
                <template slot-scope="scope">
                  <div class="danger">
                    {{ scope.row.refuseReason }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="auditTime"
                label="审核时间"
              >
                <template slot-scope="scope">
                  {{ scope.row.auditTime }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="auditUsername"
                label="审核人"
              ></el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="totalShop"
                @current-change="pagingShop"
                :page-size="pageSizeShop"
                @size-change="handleSizeChangeShop"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPageShop"
              ></el-pagination>
            </div>
          </div>
        </el-dialog>
        <el-dialog
          title="实名记录"
          :visible="changeIDCardVisible"
          @close="changeIDCardVisible = false"
          custom-class="sales-volumn-dialog"
          width="1200px"
        >
          <div>
            <el-table
              stripe
              border
              :data="changeIDCardList"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                :index="
                  (index) =>
                    index + (currentPageIDCard - 1) * pageSizeIDCard + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="operateTime"
                label="时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="applyType"
                label="类型"
              >
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.operateType === 'guider_auth_identity_info'"
                    >实名认证</span
                  >
                  <span
                    v-if="
                      scope.row.operateType === 'guider_cancel_identity_info'
                    "
                    >注销认证</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="idcardName"
                label="认证后姓名"
              >
                <template slot-scope="scope">
                  {{ JSON.parse(scope.row.operateMemo).idcardName }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="idcardNo"
                label="认证后身份证"
              >
                <template slot-scope="scope">
                  {{ JSON.parse(scope.row.operateMemo).idcardNo }}
                </template>
              </el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="totalIDCard"
                @current-change="pagingIDCard"
                :page-size="pageSizeIDCard"
                @size-change="handleSizeChangeIDCard"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPageIDCard"
              ></el-pagination>
            </div>
          </div>
        </el-dialog>
        <el-dialog
          title="黑白名单状态/变更记录"
          :visible="changeBlackWhiteVisible"
          @close="changeBlackWhiteVisible = false"
          custom-class="sales-volumn-dialog"
          width="1200px"
        >
          <div>
            <div class="mb20">{{ row.guiderName }} / {{ row.guiderPhone }}</div>
            <el-table
              stripe
              border
              :data="blackWhiteList"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                :index="
                  (index) =>
                    index + (currentPageBlackWhite - 1) * pageSizeBlackWhite + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="operateType"
                label="变更类型"
              >
                <template slot-scope="scope">
                  <div
                    v-if="JSON.parse(scope.row.operateMemo).isWhite === true"
                  >
                    白名单
                  </div>
                  <div
                    v-else-if="
                      JSON.parse(scope.row.operateMemo).isWhite === false
                    "
                  >
                    黑名单
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="operateName"
                label="操作人"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="createTime"
                label="变更时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="refuseReason"
                label="变更原因"
              >
                <template slot-scope="scope">
                  <div>
                    {{ JSON.parse(scope.row.operateMemo).refuseReason }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="refuseReasonVoucher"
                label="操作凭证"
              >
                <template slot-scope="scope">
                  <a
                    :href="
                      JSON.parse(scope.row.operateMemo).refuseReasonVoucher
                    "
                    target="_blank"
                    ><div>
                      {{
                        JSON.parse(scope.row.operateMemo).refuseReasonVoucher
                      }}
                    </div></a
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="totalblackWhite"
                @current-change="pagingBlackWhite"
                :page-size="pageSizeBlackWhite"
                @size-change="handleSizeChangeBlackWhite"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPageBlackWhite"
              ></el-pagination>
            </div>
          </div>
        </el-dialog>
        <el-dialog
          :visible.sync="errTypeValidGoods"
          width="1000px"
          title="导入失败提示"
        >
          <div>
            <div class="flex flex-between">
              <div>
                您有
                <span class="error">{{ errInputTypeResult.length }}</span
                >条数据导入失败
              </div>
              <div>
                您有
                <span class="success"> {{ succInputTypeResult.length }}</span
                >条数据导入成功！
              </div>
            </div>
            <el-table :data="errInputTypeResult" border class="small-table">
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="商户名"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="shopName"
                label="门店名"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="guiderPhone"
                label="手机号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="failReason"
                label="失败原因"
              ></el-table-column>
            </el-table>
          </div>
        </el-dialog>
        <el-dialog :visible.sync="errVisible" width="60%" title="导入失败提示">
          <div slot="title">
            <span style="font-size: 18px; color: #303133">导入失败提示</span>
          </div>
          <div>
            <div class="flex flex-between">
              <div class="flex item-center">
                您有
                <span class="error">{{ errList.length }}</span
                >条数据导入失败
                <div @click="outputErrExcel" class="delete pointer ml10">
                  <span class="delete-icon hmicon icon-daochu"></span>
                  导出失败数据
                </div>
              </div>
              <div>
                您有
                <span class="success"> {{ succList.length }}</span
                >条数据导入成功！
              </div>
            </div>

            <el-table :data="errList" border class="small-table mt10">
              <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="商户"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="guiderPhone"
                label="手机号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="refuseReason"
                label="失败原因"
              ></el-table-column>
            </el-table>
          </div>
        </el-dialog>

        <el-dialog
          title="导入失败提示"
          :visible.sync="phoneDialogVisible"
          width="600px"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          destroy-on-close
          custom-class="phone-dialog"
        >
          <div>
            <div class="flex flex-between">
              <div class="flex item-center">
                <span class="warning">
                  您有
                  <span class="error">{{ errList.length }}</span
                  >条数据导入失败</span
                >
                <div @click="outputErrExcel" class="delete pointer ml10">
                  <span class="delete-icon hmicon icon-daochu"></span>
                  导出失败数据
                </div>
              </div>
              <div>
                <el-button @click="handleEditGuider" type="primary" size="small"
                  >确认修改为月结导购</el-button
                >
              </div>
            </div>

            <el-table
              :data="succList"
              border
              class="small-table mt10"
              :max-height="500"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="商户"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="guiderPhone"
                label="手机号"
              ></el-table-column>
            </el-table>
          </div>
          <template slot="footer">
            <el-button
              @click="phoneDialogVisible = false"
              type="primary"
              size="small"
              >确定</el-button
            >
          </template>
        </el-dialog>

        <!-- 导入导出 -->
        <el-dialog
          :visible.sync="downloadVisible"
          width="40%"
          title="下载模板"
          :close-on-click-modal="false"
        >
          <el-form
            ref="downloadForm"
            :model="downloadForm"
            :rules="downloadRules"
            label-width="100px"
          >
            <el-form-item label="导出类型" prop="downloadType">
              <el-radio-group
                v-model="downloadForm.downloadType"
                :disabled="title === '导出类型'"
              >
                <div
                  style="
                    display: flex;
                    flex-flow: column nowrap;
                    justify-content: flex-start;
                    align-items: flex-start;
                    padding-top: 12px;
                  "
                >
                  <el-radio style="margin-bottom: 10px" label="1"
                    >月结人员模板</el-radio
                  >
                  <el-radio style="margin-bottom: 10px" label="2"
                    >品牌店关联导购白名单模板</el-radio
                  >
                </div>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div class="btn-wrapper flex flex-center">
            <el-button
              size="small"
              type="primary"
              @click="dowloadConfirm('downloadForm')"
              >确 定</el-button
            >
            <el-button size="small" @click="downloadVisible = false"
              >取 消</el-button
            >
          </div>
        </el-dialog>
        <el-dialog
          :visible.sync="exportVisible"
          width="40%"
          title="导入"
          @close="closeExport"
        >
          <el-form
            ref="exportForm"
            :model="exportForm"
            :rules="exportRules"
            label-width="100px"
          >
            <el-form-item label="导入类型" prop="exportType">
              <el-radio-group
                v-model="exportForm.exportType"
                :disabled="title === '导入类型'"
              >
                <div
                  style="
                    display: flex;
                    flex-flow: column nowrap;
                    justify-content: flex-start;
                    align-items: flex-start;
                    padding-top: 12px;
                  "
                >
                  <el-radio style="margin-bottom: 10px" label="1"
                    >月结人员模板</el-radio
                  >
                  <el-radio style="margin-bottom: 10px" label="2"
                    >手机号查询导购商户模板</el-radio
                  >
                  <el-radio style="margin-bottom: 10px" label="3"
                    >品牌店关联导购白名单模板</el-radio
                  >
                </div>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="!uploadedFile && exportForm.exportType == '1'"
              label="上传文件"
              prop="uploaded"
            >
              <el-upload
                drag
                multiple
                class="upload-demo"
                action="javascript:;"
                :on-change="importf"
                :before-upload="beforeAvatarUpload"
                :show-file-list="false"
                :auto-upload="false"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item
              v-if="!uploadedFile && exportForm.exportType == '2'"
              label="上传文件"
              prop="uploaded"
            >
              <el-upload
                drag
                multiple
                class="upload-demo"
                action="javascript:;"
                :on-change="importfPhone"
                :before-upload="beforeAvatarUpload"
                :show-file-list="false"
                :auto-upload="false"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item
              v-if="!uploadedFile && exportForm.exportType == '3'"
              label="上传文件"
              prop="uploaded"
            >
              <el-upload
                drag
                multiple
                class="upload-demo"
                action="javascript:;"
                :on-change="importfShopTypeAboutGuide"
                :before-upload="beforeAvatarUpload"
                :show-file-list="false"
                :auto-upload="false"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="uploadedFile">
              <div class="delete mr20 pointer open-file">
                <span class="delete-icon hmicon el-icon-s-order"></span>
                {{ filesName }}
              </div>
            </el-form-item>
          </el-form>
          <div class="btn-wrapper flex flex-center">
            <el-button
              size="small"
              type="primary"
              @click="exportConfirm('downloadForm')"
              >确 定</el-button
            >
            <el-button size="small" @click="closeExport">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 申报权限变更 -->
        <el-dialog
            title="申报与提现权限管理"
            border
            :visible="declareVisible"
            @close="declareReasonClose"
            width="30%"
        >
        <div class="flex item-center mb10">
          <div style="color:#000;margin-right:10px">提现限制</div>
          <el-switch
              size="mini"
              v-model="isWhite"
              active-color="#2fc348"
               @change="blackReasonClick"
          ></el-switch>
        </div>
         <div class="flex item-center mb10">
          <div style="color:#000;margin-right:10px">申报限制</div>
          <el-switch
              v-model="isAllowDeclare"
              active-value="0"
              inactive-value="1"
              active-color="#2fc348"
            >
            </el-switch>
        </div>
          <div class="mb10 flex flex-between item-center">
            <el-input
                clearable
                v-model.trim="refuseReason"
                placeholder="请填写变更原因"
                style="width: 360px;"
                type="textarea"
                :rows="6"
            ></el-input>
          </div>
          <div>
            <el-upload
                class="flex"
                ref="eluploadMainPic"
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onSuccess="uploadMainPicSucc2"
                :beforeUpload="beforeUpload"
                :show-file-list="uploadShow"
            >
              <div class="flex upload-upload-btn">
                <div
                    class="btn flex flex-column flex-center open-file"
                    @click="toggleShowRefuseReasonVoucher"
                    v-if="!refuseReasonVoucher"
                >
                  <div class="add-wrapper flex flex-center">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>上传凭证</span>
                </div>
                <div v-if="refuseReasonVoucher" class="priviewbgp2 mr10 flex item-end">
                  <img :src="refuseReasonVoucher" alt="背景图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="deleteShowRefuseReasonVoucher"
                    >删除</el-button
                    >
                  </div>
                </div>
              </div>
            </el-upload>
          </div>
          <span slot="footer" class="dialog-footer flex flex-center mt20">
             <el-button @click="declareReasonClose" size="small">
              取 消</el-button>
            <el-button @click="declareChange" size="small" type="primary">
              确认</el-button>
          </span>
           <!-- <el-button @click="declareChange" size="small" type="primary" style="width:80px;height: 30px;">
              确 定</el-button
            > -->
        </el-dialog>
        <el-dialog
          title="申报权限变更记录"
          :visible="changeDeclareVisible"
          @close="changeDeclareVisible = false"
          custom-class="sales-volumn-dialog"
          width="1200px"
        >
          <div>
            <div class="mb20">{{ row.guiderName }} / {{ row.guiderPhone }}</div>
            <el-table
              stripe
              border
              :data="declareList"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                :index="
                  (index) =>
                    index + (currentPageDeclare - 1) * pageSizeDeclare + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="operType"
                label="变更类型"
              >
                <template slot-scope="scope">
                  
                  <div
                    v-if="scope.row.operType === 'denyDeclare'"
                  >
                    关闭
                  </div>
                  <div
                    v-else-if="scope.row.operType === 'allowDeclare'"
                  >
                    开启
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="operaterId"
                label="操作人"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="createTime"
                label="变更时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="operReason"
                label="变更原因"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="operReasonVoucher"
                label="操作凭证"
              >
                <template slot-scope="scope">
                  <a :href="scope.row.operReasonVoucher"
                    target="_blank">
                    <div>{{scope.row.operReasonVoucher}}</div>
                    </a>
                </template>
              </el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="totalDeclare"
                @current-change="pagingDeclare"
                :page-size="pageSizeDeclare"
                @size-change="handleSizeChangeDeclare"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPageDeclare"
              ></el-pagination>
            </div>
          </div>
        </el-dialog>
        <el-dialog
          title="登陆记录"
          :visible="loginVisible"
          @close="loginVisible = false"
          custom-class="sales-volumn-dialog"
          width="1200px"
        >
          <div>
            <el-table
              stripe
              border
              :data="loginList"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                :index="
                  (index) =>
                    index + (currentPageLogin - 1) * pageSizeLogin + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="authMobile"
                label="手机号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="createTime"
                label="登陆时间"
              ></el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="totalLogin"
                @current-change="pagingLogin"
                :page-size="pageSizeLogin"
                @size-change="handleSizeChangeLogin"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPageLogin"
              ></el-pagination>
            </div>
          </div>
        </el-dialog>
         <el-dialog
          title="签名列表"
          :visible="changeSignatureVisible"
          @close="changeSignatureVisible = false"
          custom-class="sales-volumn-dialog"
          width="1200px"
        >
          <div>
            <el-table
              stripe
              border
              :data="changeSignatureList"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                :index="
                  (index) => index + (currentPageSignature - 1) * pageSizeSignature + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="idcardName"
                label="姓名"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="createTime"
                label="申请时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="handwrittenImg"
                label="签名照片"
              >
              <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-image
                      v-if="scope.row.handwrittenImg"
                      style="width: 100px; height: 100px"
                      :src="scope.row.handwrittenImg"
                      :preview-src-list="[scope.row.handwrittenImg]"
                    >
                    </el-image>
                    <span v-else>未上传图片</span>
                  </div>
                </template>
              </el-table-column>
               <el-table-column
                label="操作"
                width="100">
                <template slot-scope="scope">
                  <el-button @click="signaturehandleClick(scope.row)" type="text" size="small">查看签名协议</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="totalSignature"
                @current-change="pagingSignature"
                :page-size="pageSizeSignature"
                @size-change="handleSizeChangeSignature"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPageSignature"
              ></el-pagination>
            </div>
          </div>
        </el-dialog>
        <el-dialog
          title="查看协议签名"
          :visible="checkSignatureVisible"
          @close="checkSignatureVisible = false"
          custom-class="sales-volumn-dialog"
          width="800px"
        >
     <div ref="captureContainer" class="signature-popup-wrapper">
	    <div class="ts-title">
	      税务申报通知
	    </div>
			<div class="ts-box topBox">
				<div class="topBox1">
					<div>
						提现金额：￥{{signatureData.getcashMoney}}
					</div>
					<div>
						申请人：{{signatureData.customerName}}
					</div>
				</div>
				<div class="">
					申请时间：{{signatureData.currentTime}}
				</div>
			</div>
      <div class="ts-box">
        <!-- <div class="ts-icon">!</div> -->
        <div style="text-align: left;">
          <div v-html="signatureData.richText"></div>
      </div>
	  
	  </div>
        <div class="preview-area">
          <!-- <div class="preview-title">签名:</div> -->
          <div class="preview-content">
          <img class="preview-char" :src="signatureData.signatureUrl" alt="签名" />
          </div>
        </div>
	  </div>
    
    <!-- 按钮区域 -->
    <div class="button-container">
      <el-button type="primary" @click="generateImage">保存图片</el-button>
    </div>
        </el-dialog>
         <el-dialog
          title="查看非自动加品牌变更记录"
          :visible="changeRecordsVisible"
          @close="changeRecordsVisible = false"
          custom-class="sales-volumn-dialog"
          width="1200px"
        >
          <div>
            <el-table
              stripe
              border
              :data="changeRecordsList"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                :index="
                  (index) => index + (currentPageRecords - 1) * pageSizeRecords + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="supplierName"
                label="供应商"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="createTime"
                label="变更时间"
              ></el-table-column>
                 <el-table-column
                header-align="center"
                align="center"
                prop="realname"
                label="操作人"
              ></el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="totalRecords"
                @current-change="pagingRecords"
                :page-size="pageSizeRecords"
                @size-change="handleSizeChangeRecords"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPageRecords"
              ></el-pagination>
            </div>
          </div>
        </el-dialog>
      </hm-content>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { getLoginUser } from "@/utils/auth";
// import XLSX from "xlsx";
import * as XLSX from "xlsx/xlsx";
import { arrayUnique2, setCookie, getCookie } from "@/utils/utils";
import moment from "moment";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {},
  data() {
    return {
      exportVisible: false,
      downloadVisible: false,
      uploadedFile: false,
      title: "",
      typeChange: "",
      downloadForm: {
        downloadType: "1",
      },
      downloadRules: {
        downloadType: {
          required: true,
          message: "请选择模板类型",
          trigger: "blur",
        },
      },
      exportForm: {
        exportType: "1",
        uploadFile: "",
      },
      exportRules: {
        exportType: {
          required: true,
          message: "请选择模板类型",
          trigger: "blur",
        },
        uploadFile: {
          required: true,
          message: "请上传文件",
          trigger: "blur",
        },
      },
      changeShopVisible: false,
      totalShop: 0,
      currentPageShop: 1,
      pageSizeShop: 10,
      changeShopList: [],
      hidden: true,
      auditState: "all",
      isAllowDeclare: "0",
      isWhite:false,
      forbidISWhite: false,
      rejectReason: "",
      reason: "",
      detailsVisible: false,
      detailsShop: false,
      isOutputing: false,
      searchCondition: {
        applyDate: [],
      },
      currentPage: 1,
      pageSize: 10,
      tabPosition: "all",
      activeTab: 0,
      list: [],
      total: 0,
      ruleForm: {
        refuseReason: "",
      },
      rules: {
        refuseReason: {
          required: true,
          message: "请输入驳回原因",
          trigger: "change",
        },
      },
      ruleFormShop: {
        shopId: "",
        storeCode: "",
      },
      rulesShop: {
        shopId: {
          required: true,
          message: "请选择门店!",
          trigger: "change",
        },
        storeCode: {
          required: true,
          message: "请选择商户!",
          trigger: "change",
        },
      },
      rejectTemp: [
        "图片不清。",
        "门头缺失/拍摄不完善。",
        "工牌缺失/工牌拍摄不全。",
        "人物图像不清晰或不完善。",
      ],
      // 移动端data
      keywords: "",
      tabList: [
        {
          name: "待审核",
        },
        {
          name: "已审核",
        },
        {
          name: "已驳回",
        },
      ],
      loading: false,
      noMore: false,
      mobileList: [
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华",
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华",
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华",
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华",
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华",
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华",
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华",
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华",
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华",
        },
      ],
      result: {},
      row: {},
      shopList: [],
      allMerchant: [],
      errList: [],
      succList: [],
      errVisible: false,
      storeBasicList: [],
      errTypeValidGoods: false,
      errInputTypeResult: [],
      succInputTypeResult: [],
      changeIDCardVisible: false,
      totalIDCard: 0,
      currentPageIDCard: 1,
      pageSizeIDCard: 10,
      changeIDCardList: [],
      blackWhiteList: [],
      totalblackWhite: 0,
      currentPageBlackWhite: 1,
      pageSizeBlackWhite: 10,
      changeBlackWhiteVisible: false,
      storeCode: "",
      phoneDialogVisible: false,

      // 申报变更
      declareVisible: false,
      uploadShow: false,
      refuseReason: "",
      showRefuseReasonVoucher: false,
      refuseReasonVoucher: "",
      chooseRow: '',
      changeDeclareVisible: false,
      pageSizeDeclare: 10,
      currentPageDeclare: 1,
      totalDeclare: 0,
      declareList: [],
      // 登陆记录
      loginVisible: false,
      pageSizeLogin: 10,
      currentPageLogin: 1,
      totalLogin: 0,
      loginList: [],
      //签名列表
      changeSignatureVisible:false,
      changeSignatureList:[],
      totalSignature:0,
      pageSizeSignature:10,
      currentPageSignature:1,
      checkSignatureVisible:false,
      signatureData: {},
      generatedImageUrl:'',
      // 选择供应商品牌
      supplierBrand:false,
      // checkedSupplierBrandAll: 0,
       supplierBrandList: [],
      // 变更记录 
      changeRecordsVisible:false,
      totalRecords:0,
      pageSizeRecords:10,
      currentPageRecords:1,
      changeRecordsList:[]
    };
  },
  computed: {
    checkedSupplierBrandAll() {
      return this.supplierBrandList
        .filter(item => item.checked) // 筛选出 checked 为 true 的项
        .map(item => item.supplierCode); // 提取 supplierCode 组成新数组
    }
  },
  watch: {},
  created() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    // const startTime = moment().startOf("day").subtract(6, "days").format("YYYY-MM-DD HH:mm:ss");
    // const endTime = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    // this.searchCondition.applyDate = [startTime, endTime];
    // this.queryGuiderDeclareCountAll();
    this.getCookie();
    // this.queryList();
    this.queryAllMerchant();
  },
  methods: {
    dowloadConfirm() {
      console.log("导出模板类型", this.downloadForm);
      if (this.downloadForm.downloadType == 1) {
        this.outputExcel();
      } else if (this.downloadForm.downloadType == 2) {
        this.outputShopTypeExcel();
      }
    },
    //导入统一
    exportConfirm() {
      let that = this;
      console.log("导入数据", this.exportForm);
      if (
        this.exportForm.exportType != "" &&
        this.exportForm.uploadFile != ""
      ) {
        if (this.exportForm.exportType == 1) {
          that.$store
            .dispatch(
              "importMonthlyStatementGuider",
              that.exportForm.uploadFile
            )
            .then((res) => {
              const { code, result } = res;
              if (code === "0") {
                const { errList, succList } = result;
                that.errList = errList;
                that.succList = succList;
                that.exportVisible = false;
                that.uploadedFile = false;
                that.filesName = "";
                that.exportForm = {
                  exportType: "1",
                  uploadFile: "",
                };
                that.$nextTick(() => {
                  that.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  that.queryList();
                  if (errList && errList.length > 0) {
                    that.errVisible = true;
                  }
                });
              }
            });
        } else if (this.exportForm.exportType == 2) {
          const guiderPhoneList = that.exportForm.uploadFile.map(
            (item) => item.guiderPhone
          );
          that.$store
            .dispatch("mobileByStoreNameList", {
              storeCode: that.storeCode,
              guiderPhoneList,
            })
            .then((res) => {
              const { code, result } = res;
              if (code === "0") {
                const { mobileFalseStoreNameList, mobileTrueStoreNameList } =
                  result;
                that.errList = mobileFalseStoreNameList.map((item) => {
                  return { guiderPhone: item };
                });
                that.succList = mobileTrueStoreNameList;
                that.exportVisible = false;
                that.uploadedFile = false;
                that.filesName = "";
                that.exportForm = {
                  exportType: "1",
                  uploadFile: "",
                };
                that.$nextTick(() => {
                  that.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  that.queryList();
                  that.phoneDialogVisible = true;
                });
              }
            });
        } else if (this.exportForm.exportType == 3) {
          that.$store
            .dispatch("importShopTypeGuider", formatResult)
            .then((res) => {
              const { code, result } = res;
              if (code === "0") {
                if (result.errList) {
                  console.log("1111");
                  that.errTypeValidGoods = true;
                  that.errInputTypeResult = result.errList;
                  console.log(that.errTypeValidGoods, that.errInputTypeResult);
                  // that.$message({
                  //   message: "部分导入失败！",
                  //   type: "warning",
                  // });
                } else {
                  that.exportVisible = false;
                  that.uploadedFile = false;
                  that.filesName = "";
                  that.exportForm = {
                    exportType: "1",
                    uploadFile: "",
                  };
                  that.$nextTick(() => {
                    that.$message({
                      message: "导入成功！",
                      type: "success",
                    });
                    that.queryList();
                    that.phoneDialogVisible = true;
                    that.succInputTypeResult = result.successList;
                  });
                }
                that.queryList();

                // that.addGoodsList.push(...result.successList);
              }
            });
        }
      } else {
        this.$message({
          message: "请选择导入模板类型和上传文件",
          type: "warning",
        });
      }
    },
    beforeAvatarUpload(file) {
      console.log(this.typeChange, "类型");
      // 限制上传文件的类型
      const isExcel =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      if (!isExcel) {
        this.$message.error("上传文件只能是 Excel 格式!");
        return false;
      }
      return true;
    },
    closeExport() {
      this.exportVisible = false;
      this.uploadedFile = false;
      this.filesName = "";
      this.exportForm = {
        exportType: "1",
        uploadFile: "",
      };
      this.exportVisible = false;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    outputErrExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        let tHeader = [];
        let filterVal = [];
        let title = "";
        if (this.phoneDialogVisible) {
          tHeader = ["商户名称", "导购手机号"];
          filterVal = ["storeName", "guiderPhone"];
          title = "手机号查询导购商户导入失败数据";
        } else {
          tHeader = ["商户名称", "导购手机号", "失败原因"];
          filterVal = ["storeName", "guiderPhone", "refuseReason"];
          title = "月结导购导入失败数据";
        }
        const data = this.formatJson(filterVal, this.errList);

        exportJsonToExcel(tHeader, data, title);
      });
    },
    //导入excel设置品牌店
    importfShopTypeAboutGuide(e) {
      // const obj = e.target;
      const that = this;
      that.inputData = [];
      that.filesName = e.name;
      // if (!obj.files) {
      //   return;
      // }
      // let f = obj.files[0];
      if (!e.raw) {
        return;
      }
      let f = e.raw;
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        console.log("表格解析数据", result);
        result.forEach((v) => {
          formatResult.push({
            supplierName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
            storeName: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
            shopName: v[2] ? (v[2] + "").replace(/\s*/g, "") : "",
            guiderPhone: v[3] ? (v[3] + "").replace(/\s*/g, "") : "",
          });
        });
        console.log("处理后的数据", formatResult);
        that.uploadedFile = true;
        that.exportForm.uploadFile = formatResult;

        // sessionStorage.setItem("redPackageImportStoreList", JSON.stringify(formatResult));
        // that.toUrl("ImportMerchantManage");
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      // obj.value = "";
      e.value = "";
    },
    importfPhone(e) {
      console.log(this.typeChange, "皮");
      // const obj = e.target;
      const that = this;
      that.inputData = [];
      that.filesName = e.name;
      // if (!obj.files) {
      //   return;
      // }
      // let f = obj.files[0];
      if (!e.raw) {
        return;
      }
      let f = e.raw;
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let formatResult = [];
        result.forEach((v) => {
          if (v[0] || v[1]) {
            formatResult.push({
              storeName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              guiderPhone: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
            });
          }
        });

        formatResult = arrayUnique2(formatResult, "guiderPhone");
        that.uploadedFile = true;
        that.exportForm.uploadFile = formatResult;

        // goodsSns = unique(goodsSns);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      // obj.value = "";
      e.value = "";
    },
    importf(e) {
      console.log(this.typeChange, "皮");
      // const obj = e.target;
      const that = this;
      that.inputData = [];
      that.filesName = e.name;
      // if (!obj.files) {
      //   return;
      // }
      // let f = obj.files[0];
      if (!e.raw) {
        return;
      }
      let f = e.raw;
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let formatResult = [];
        result.forEach((v) => {
          if (v[0] || v[1]) {
            formatResult.push({
              storeName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              guiderPhone: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
            });
          }
        });

        formatResult = arrayUnique2(formatResult, "guiderPhone");
        that.uploadedFile = true;
        that.exportForm.uploadFile = formatResult;

        // goodsSns = unique(goodsSns);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      // obj.value = "";
      e.value = "";
    },
    outputShopTypeExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["供应商", "商户", "门店", "导购手机号"];
        const data = [];

        this.downloadVisible = false;
        exportJsonToExcel(tHeader, data, "关联导购模板");
      });
    },
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商户名称", "导购手机号"];
        const data = [];

        this.downloadVisible = false;
        exportJsonToExcel(tHeader, data, "月结人员模板");
      });
    },
    changeMonthlyStatementFlag(row) {
      this.row = row;
      if (row.monthlyStatementFlag) {
        row.monthlyStatementFlag = false;
        // this.saveMonthlyStatementShop(row);
        this.guiderViewSupplierBrand()
      } else {
        row.monthlyStatementFlag = true;
        this.updateShop(row);
      }
    },
    blackReasonClick() {
      if(!this.forbidISWhite){
          this.isWhite = false
      }
    },
    changeGuiderState(row) {
      this.forbidISWhite = row.isWhite
      this.isWhite = row.isWhite
      this.isAllowDeclare = row.isAllowDeclare
      this.chooseRow = row
      this.declareVisible = true
      console.log(row,99999999999)
    },
    async saveMonthlyStatementShop(row) {
      let params = JSON.parse(JSON.stringify(row));
      await this.$store.dispatch("saveMonthlyStatementShop", params);
      this.$message({
        message: "操作成功",
        type: "success",
      });
      this.supplierBrand = false
      this.queryList();
    },
    async changeGuiderDeclareState(row) {
      let params = JSON.parse(JSON.stringify(row));
      if(!this.isWhite) {
        let paramstwo = {
          guiderId: row.guiderId,
          isWhite: false,
          refuseReason: row.operReason,
          refuseReasonVoucher: row.operReasonVoucher,
        };
        await this.$store.dispatch("managerGuiderEdit", paramstwo)
      }
      if(this.isAllowDeclare !=row.isAllowDeclare) {
        await this.$store.dispatch("changeGuiderDeclareState", params);
      }
       this.$message({
                message: "操作成功",
                type: "success",
        });
      this.declareVisible = false
      this.refuseReason = ''
      this.showRefuseReasonVoucher = false
      this.refuseReasonVoucher = ''
      this.uploadShow = false
      this.queryList();
    },
    pagingShop(page) {
      this.currentPageShop = page;
      this.queryChangShopList();
    },
    handleSizeChangeShop(size) {
      this.currentPageShop = 1;
      this.pageSizeShop = size;
      this.queryChangShopList();
    },
    async queryChangShopList() {
      let params = {
        pageSize: this.pageSizeShop,
        pageNo: this.currentPageShop,
        guiderId: this.row.guiderId,
      };
      const { result } = await this.$store.dispatch("guiderOperate", params);
      const { records, total } = result;
      this.changeShopList = records;
      this.totalShop = total;
    },
    pagingIDCard(page) {
      this.currentPageIDCard = page;
      this.queryChangIDCardList();
    },
    handleSizeChangeIDCard(size) {
      this.currentPageIDCard = 1;
      this.pageSizeIDCard = size;
      this.queryChangIDCardList();
    },
    async queryChangIDCardList() {
      let params = {
        pageSize: this.pageSizeIDCard,
        pageNo: this.currentPageIDCard,
        operateTypeList: [
          "guider_auth_identity_info",
          "guider_cancel_identity_info",
        ],
        operateColumnValue: this.row.customerId,
      };
      const { result } = await this.$store.dispatch(
        "queryPageListByModel",
        params
      );
      const { records, total } = result;
      this.changeIDCardList = records;
      this.totalIDCard = total;
    },
    async queryAllMerchant() {
      const { result } = await this.$store.dispatch(
        "queryStoreBasicListComboBox"
      );
      this.allMerchant = result;
    },
    switchTabs() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.list = [];
      this.queryList();
    },
    switchRejectReason() {
      this.ruleForm.refuseReason = this.rejectTemp[this.rejectReason];
    },
    reject(row) {
      this.detailsVisible = true;
      this.row = row;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    outputDetail() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        auditState: this.auditState === "all" ? "" : this.auditState,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.startTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      this.$store.dispatch("exoprtGuiderDeclareList", params);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.hidden = false;
      }, 0);
    },
    outputDetail1() {
      // let params = {
      //   pageSize: this.pageSize,
      //   pageNo: this.currentPage,
      //   auditState: this.auditState === "all" ? "" : this.auditState,
      // };
      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // searchCondition.startTime =
      //   this.searchCondition.applyDate &&
      //   this.searchCondition.applyDate.length > 0
      //     ? this.searchCondition.applyDate[0]
      //     : "";
      // searchCondition.endTime =
      //   this.searchCondition.applyDate &&
      //   this.searchCondition.applyDate.length > 0
      //     ? this.searchCondition.applyDate[1]
      //     : "";
      // Object.assign(params, searchCondition);
      // this.$store.dispatch("exportguiderDeclareOperatelist", params);
      // setTimeout(() => {
      //   this.$message({
      //     message: "已加入导出队列正在生成报表，请在导出列队中查看！",
      //     type: "success",
      //   });
      //   this.hidden = false;
      // }, 0);
      this.$store.dispatch("exportCustomReport", { 
               reportCode: "manager_guider_operate_new",
               param:{
                guider_phone:this.searchCondition.keyWord,
                guider_name:this.searchCondition.keyWord,
                store_code:this.searchCondition.storeCode,
                declare_time: this.searchCondition.applyDate
               }
            })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "已加入导出队列正在生成报表，请在导出列队中查看！",
                  type: "success",
                });
              }
            });
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        auditState: this.auditState === "all" ? "" : this.auditState,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.startTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      if (
        !searchCondition.storeCode &&
        !searchCondition.startTime &&
        !searchCondition.startTime &&
        !searchCondition.keyWord
      ) {
        this.$message({
          type: "warning",
          message: "请先选择查询条件",
        });
        return false;
      }
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryGuiderDeclareList",
        params
      );
      // this.result = result;
      this.list = result.records.records;
      this.total = result.records.total;
    },
    async queryGuiderDeclareCountAll() {
      let params = {};
      const { result } = await this.$store.dispatch(
        "queryGuiderDeclareCountAll",
        params
      );
      console.log("queryGuiderDeclareCountAll:", result);
      this.result = result;
      let cookieTime = moment().format("YYYY-MM-DD");
      setCookie({
        key: "countAll",
        type: "session",
        data: {
          cookieTime: cookieTime,
          result: this.result,
        },
      });
    },
    getCookie() {
      const countAll = getCookie({
        key: "countAll",
        type: "session",
      });
      console.log("countAll:", countAll);
      if (countAll && countAll.cookieTime === moment().format("YYYY-MM-DD")) {
        this.result = countAll.result;
      } else {
        this.queryGuiderDeclareCountAll();
      }
    },
    async changeRecord(row) {
      this.changeShopVisible = true;
      this.row = row;
      this.pageSizeShop = 10;
      this.currentPageShop = 1;
      this.queryChangShopList();
    },
    async changeIDCardRecord(row) {
      this.changeIDCardVisible = true;
      this.row = row;
      this.pageSizeIDCard = 10;
      this.currentPageIDCard = 1;
      this.queryChangIDCardList();
    },
    async updateShop(row) {
      this.row = row;
      this.detailsShop = true;
      let params = {
        pageSize: 99999,
        pageNo: 1,
        storeCode: row.storeCode,
      };
      this.$store.dispatch("queryStoreShopInfoList", params).then((res) => {
        // this.shopList = res.result.records;
         this.shopList = res.result.records.filter(shop => shop.shopId !== row.shopId);
      });
    },
    async audit(row) {
      const result = await this.$confirm(`是否同意？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      if (result === "confirm") {
        let params = {
          auditState: "agree",
          guiderId: row.guiderId,
          addSwitchShopRecord: "yes",
          shopId: row.shopId,
        };
        const { code } = await this.$store.dispatch(
          "guiderDeclareOperate",
          params
        );

        if (code === "0") {
          this.$message({
            message: "操作成功!",
            type: "success",
          });
          this.queryList();
        }
      }
    },
    async editShop(ruleForm) {
      const vaild = await this.$refs[ruleForm].validate();
      if (vaild) {
        let params = {
          guiderId: this.row.guiderId,
          addSwitchShopRecord: "yes",
        };
        Object.assign(params, this.ruleFormShop);

        const { code } = await this.$store.dispatch(
          "guiderDeclareOperate",
          params
        );

        if (code === "0") {
          this.detailsShop = false;
          this.$message({
            message: "操作成功!",
            type: "success",
          });
          setTimeout(() => {
            this.resetRuleForm("ruleFormShop");
          }, 0);
          this.queryList();
        }
      }
    },
    async submitReject() {
      const valid = await this.$refs.ruleForm.validate();
      if (valid) {
        // this.ruleForm.auditState = "refuse";
        let params = JSON.parse(JSON.stringify(this.row));
        params.auditState = "refuse";
        params.addSwitchShopRecord = "yes";
        Object.assign(params, this.ruleForm);
        const { code } = await this.$store.dispatch(
          "guiderDeclareOperate",
          params
        );

        if (code === "0") {
          this.detailsVisible = false;
          this.$message({
            message: "操作成功!",
            type: "success",
          });
          setTimeout(() => {
            this.resetRuleForm("ruleForm");
          }, 0);

          this.queryList();
        }
      } else {
        return false;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    resetRuleForm(ruleForm) {
      this.$refs[ruleForm].resetFields();
    },
    remoteMethod(query) {
      if (query !== "") {
        this.storeBasicList = this.allMerchant.filter(
          (v) => v.storeName.indexOf(query) > -1
        );
      } else {
        this.storeBasicList = [];
      }
    },
    changeBlackWhiteRecord(row) {
      this.changeBlackWhiteVisible = true;
      this.row = row;
      this.pageSizeBlackWhite = 10;
      this.currentPageBlackWhite = 1;
      this.queryBlackWhiteList();
    },
    async queryBlackWhiteList() {
      let params = {
        pageSize: this.pageSizeBlackWhite,
        pageNo: this.currentPageBlackWhite,
        operateTypeList: ["edit_guider_white_list"],
        operateColumnValue: this.row.guiderId,
      };
      const { result } = await this.$store.dispatch(
        "queryPageListByModel",
        params
      );
      const { records, total } = result;
      this.blackWhiteList = records;
      this.totalblackWhite = total;
    },
    pagingBlackWhite(page) {
      this.currentPageBlackWhite = page;
      this.queryBlackWhiteList();
    },
    handleSizeChangeBlackWhite(size) {
      this.currentPageBlackWhite = 1;
      this.pageSizeBlackWhite = size;
      this.queryBlackWhiteList();
    },
    async queryShop(storeCode) {
      this.shopList = [];
      this.ruleFormShop.shopId = "";
      let params = {
        pageSize: 99999,
        pageNo: 1,
        storeCode: storeCode,
      };
      this.$store.dispatch("queryStoreShopInfoList", params).then((res) => {
        // this.shopList = res.result.records;
        this.shopList = res.result.records.filter(shop => shop.shopId !== this.row.shopId);
      });
    },
    closeShop() {
      this.$refs.ruleFormShop.resetFields();
      this.detailsShop = false;
    },
    /**
     * @desc 确认修改为月结导购
     */
    handleEditGuider() {
      const list = this.succList.map((item) => {
        return {
          storeName: item.storeName,
          guiderPhone: item.guiderPhone,
        };
      });
      this.phoneDialogVisible = false;
      this.errList = [];
      this.succList = [];
      this.$store.dispatch("importMonthlyStatementGuider", list).then((res) => {
        const { code, result } = res;
        if (code === "0") {
          const { errList, succList } = result;
          this.errList = errList;
          this.succList = succList;
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.queryList();
          if (errList && errList.length > 0) {
            this.errVisible = true;
          }
        }
      });
    },
    // 申报变更
    uploadMainPicSucc2(jsonData) {
      if (jsonData.code === 0) {
        this.refuseReasonVoucher = jsonData.result;
        this.uploadShow = false
      }
    },
    beforeUpload(file) {
      console.log("file: ", file);
      const extension =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpeg";
      const extension3 =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      //   const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      //   if (!limitSize) {
      //     this.$message({
      //       message: "上传模板大小不能超过 1M!",
      //       type: "warning"
      //     });
      //   }
      return extension || extension2 || extension3 || extension4;
    },
    declareReasonClose() {
      this.declareVisible = false;
      this.refuseReason = ''
      this.showRefuseReasonVoucher = false
      this.refuseReasonVoucher = ''
      this.uploadShow = false
    },
    toggleShowRefuseReasonVoucher(){
      this.showRefuseReasonVoucher = !this.showRefuseReasonVoucher;
    },
    deleteShowRefuseReasonVoucher(){
      this.refuseReasonVoucher = "";
      this.$refs.eluploadMainPic.clearFiles()
    },
    declareChange(){
      if (this.refuseReason == '') {
        this.$message({
          message: "请输入原因",
          type: "warning"
        });
        return;
      }
      if (this.refuseReasonVoucher == '') {
        this.$message({
          message: "请上传凭证",
          type: "warning"
        });
        return;
      }
        // this.chooseRow.isAllowDeclare = this.isAllowDeclare;
        // this.chooseRow.isWhite = this.isWhite
      // if ((this.chooseRow.isAllowDeclare == "0")) {
      //   this.chooseRow.isAllowDeclare = "1";
      // } else {
      //   this.chooseRow.isAllowDeclare = "0";
      // }
      this.chooseRow.operReason = this.refuseReason
      this.chooseRow.operReasonVoucher = this.refuseReasonVoucher
      this.changeGuiderDeclareState(this.chooseRow);
    },
    changeDeclareRecord(row) {
      this.changeDeclareVisible = true;
      this.row = row;
      this.pageSizeDeclare = 10;
      this.currentPageDeclare = 1;
      this.queryDeclareList();
    },
    async queryDeclareList() {
      let params = {
        pageSize: this.pageSizeDeclare,
        pageNo: this.currentPageDeclare,
        guiderMobile: this.row.guiderPhone
      };
      const { result } = await this.$store.dispatch(
        "declareQueryPageList",
        params
      );
      const { records, total } = result;
      this.declareList = records;
      this.totalDeclare = total;
    },
    pagingDeclare(page) {
      this.currentPageDeclare = page;
      this.queryDeclareList();
    },
    handleSizeChangeDeclare(size) {
      this.currentPageDeclare = 1;
      this.pageSizeDeclare = size;
      this.queryDeclareList();
    },
    // 登陆记录
    loginRecord(row) {
      this.loginVisible = true;
      this.row = row;
      this.pageSizeLogin = 10;
      this.currentPageLogin = 1;
      this.queryLoginList();
    },
    pagingLogin(page) {
      this.currentPageLogin = page;
      this.queryLoginList();
    },
    handleSizeChangeLogin(size) {
      this.currentPageLogin = 1;
      this.pageSizeLogin = size;
      this.queryLoginList();
    },
    async queryLoginList() {
      let params = {
        pageSize: this.pageSizeLogin,
        pageNo: this.currentPageLogin,
        authMobile: this.row.guiderPhone
      };
      const { result } = await this.$store.dispatch(
        "loginQueryPageList",
        params
      );
      const { records, total } = result;
      this.loginList = records;
      this.totalLogin = total;
    },
    // 签名列表
      pagingSignature(page) {
      this.currentPageSignature = page;
      this.signatureQueryPageList();
    },
    handleSizeChangeSignature(size) {
      this.currentPageSignature = 1;
      this.pageSizeSignature = size;
      this.signatureQueryPageList();
    },
    signatureList(row) {
      this.row = row
        this.changeSignatureVisible = true
        this.pageSizeSignature = 10
        this.currentPageSignature = 1 
      this.signatureQueryPageList()
    },
    signaturehandleClick(row) {
      this.signatureQueryById(row.id)
    },
    async signatureQueryPageList() {
      let params = {
        pageSize: this.pageSizeSignature,
        pageNo: this.currentPageSignature,
        customerId: this.row.customerId,
        handwrittenVerifyState:'pass'
      };
      const { result } = await this.$store.dispatch(
        "signatureQueryPageList",
        params
      );
      const { records, total } = result;
      this.changeSignatureList = records;
      this.totalSignature = total;
    },
    async signatureQueryById(id) {
      let params = {
        id
      };
      const { result } = await this.$store.dispatch(
        "signatureQueryById",
        params
      );
      // this.signatureData = result;
      if(result) {
        let handwrittenLayout = JSON.parse(result.handwrittenLayout);
        this.signatureData = {
          getcashMoney:handwrittenLayout.getcashMoney,
          customerName:handwrittenLayout.signName,
          currentTime:handwrittenLayout.applicationTime,
          richText:result.handwrittenAgreement,
          signatureUrl:result.handwrittenImg
        }
      }
      this.checkSignatureVisible = true;

      
      // this.iamgeSS = 'https://redpackagecdn.hemiao100.com/CustomerRiskControl/32ed7893dcf14f5fb915da62ef7c94c0/2025-05-23/1748007409124-6c9abb1b-22dc-4553.jpg'
      // this.changeSignatureList = records;
      // this.totalSignature = total;
    },
     // 生成图片
    async generateImage() {
      try {
        // 等待DOM更新完成
        await this.$nextTick();
        
        const container = this.$refs.captureContainer;
        
        // 使用html2canvas将DOM转换为canvas
        const canvas = await html2canvas(container, {
          scale: 2, // 提高分辨率
          useCORS: true, // 允许跨域图片
          logging: false // 关闭日志
        });
        
        // 将canvas转换为图片URL
        const imageUrl = canvas.toDataURL('image/png');
        
        // 保存图片URL
        this.generatedImageUrl = imageUrl;
        
        // 如果需要下载图片，可以使用以下代码
        this.downloadImage(imageUrl);
      } catch (error) {
        console.error('生成图片失败', error);
      }
    },
    
    // 下载图片
    downloadImage(imageUrl) {
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = '签名协议.png';
      link.click();
    },
     // 查询供应商品牌
    guiderViewSupplierBrand() {
       this.supplierBrandList = []
       let params = {
          guiderId: this.row.guiderId,
       }
        this.$store.dispatch(
        "guiderViewSupplierBrand",
        params
      ).then(res => { 
          if(res.code == '0' && (res.result.supplierBrandList && res.result.supplierBrandList.length)) {
          //  this.supplierBrandList = res.result.supplierBrandList
          this.supplierBrandList = res.result.supplierBrandList.filter(
              item => item.guiderAllow === 'no'
            );
          }else {
            this.supplierBrandList = []
          }
           this.supplierBrand = true
        })
    },
    // 保存品牌
    affirmSupplierBrand() {
      if(this.checkedSupplierBrandAll.length) {
        let params = {
          // supplierCode:"",
          supplierCodeList: this.checkedSupplierBrandAll,
          guiderId: this.row.guiderId,
          useScene: "allowGuiderAutoAddSupplierBrand",
          configValue:"yes"

        }
        this.$store.dispatch(
        "hemiaoSetGuiderConfig",
        params
      ).then(res => { 
          if(res.code == '0') {
            this.saveMonthlyStatementShop(this.row);
            this.supplierBrand = false
          }
        })
      }else {
         this.saveMonthlyStatementShop(this.row);
      }
    },
    // 查看非自动加入品牌变更记录
    changeRecords(row) {
      this.row = row
      this.changeRecordsVisible = true
      this.supplierGuiderConfigHisChangeRecord()
    },
      pagingRecords(page) {
      this.currentPageRecords = page;
      this.supplierGuiderConfigHisChangeRecord();
    },
    handleSizeChangeRecords(size) {
      this.currentPageRecords = 1;
      this.pageSizeRecords = size;
      this.supplierGuiderConfigHisChangeRecord();
    },
     supplierGuiderConfigHisChangeRecord() {
        let params = {
          guiderId: this.row.guiderId,
          pageSize: this.pageSizeRecords,
          pageNo: this.currentPageRecords,
          useScene: "allowGuiderAutoAddSupplierBrand"
        }
        this.$store.dispatch(
        "queryGuiderConfigHisList",
        params
      ).then(res => { 
        this.changeRecordsList = res.result.records
         this.totalRecords = res.result.total
        })
      
    }
  },
};
</script>
<style lang="scss">
.sales-volumn-dialog {
  width: 800px;
}
@media screen and (max-width: 600px) {
  .sales-volumn-dialog {
    width: 320px;
  }
}
.reject-reason {
  .el-radio__label {
    white-space: normal;
    line-height: 24px;
  }
}
</style>
<style lang="scss" scoped>
.income {
  color: #e50065;
}
.title {
  width: 85px;
  text-align: right;
}

@media screen and (max-width: 414px) {
  .guider-apply-container {
    .pc {
      display: none;
    }
    .mobile {
      display: block;
      margin: -10px;
      font-size: 14px;
      .list {
        background: #fff;
        .price {
          font-size: 16px;
        }
        .list-item {
          padding: 15px 15px 15px 0;
          margin-left: 15px;
          border-bottom: 1px solid #efefef;
          color: #999;
          line-height: 25px;
        }
        .count {
          color: #589dff;
        }
        .price {
          color: #f72b2b;
        }
        .tag {
          background: linear-gradient(
            -86deg,
            rgba(247, 173, 74, 1),
            rgba(255, 128, 128, 1)
          );
          color: #fff;
          font-size: 10px;
          border-radius: 30px;
          padding: 0 5px;
          margin-right: 5px;
        }
        .user-info {
          margin-right: 5px;
          color: #2b2b2b;
        }
      }
      .merchant {
        color: #005ceb;
      }
      .tabs {
        background: #fff;
        padding: 15px;
        margin-bottom: 10px;
        .tab {
          position: relative;
          &.active:after {
            content: "";
            position: absolute;
            bottom: -17px;
            left: 50%;
            width: 50%;
            transform: translateX(-50%);
            border-bottom: 4px solid #005ceb;
            border-radius: 30px;
          }
        }
      }

      .scroll-content {
        padding-bottom: 20px;
      }

      .control-panel {
        background: #fff;
        padding: 15px;
        border-bottom: 1px solid #f5f5f5;
        .ipt-wrapper {
          background: #f0f0f0;
          height: 34px;
          line-height: 34px;
          border-radius: 30px;
          border-bottom: 1px solid #f5f5f5;
          margin-right: 5px;
          padding-left: 10px;
          input {
            height: 34px;
            border: none;
            background: transparent;
            padding-left: 5px;
            font-size: 14px;
            &:focus {
              outline: none;
            }
          }
        }
      }

      .info {
        margin-top: 10px;
        line-height: 25px;
      }
    }
  }
}
// @media screen and (min-width: 415px) {
//   .guider-apply-container {
//     .pc {
//       display: block;
//     }

//     .mobile {
//       display: none;
//     }
//   }
// }
.phone-dialog {
  .warning {
    height: 20px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #ff0000;
    line-height: 20px;
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 100px;
    height: 100px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.priviewbgp2 {
  position: relative;
  width: 100px;
  height: 100px;
  padding: 10px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
  .signature-popup-wrapper {
	  width: 375px;
    margin: 0 auto;
    background: #f9fafb !important;
    padding-bottom: 20px; /* 增加底部内边距 */
    position: relative; /* 确保绝对定位元素正确计算 */
    overflow: visible !important; /* 防止内容被裁剪 */
	  .ts-title {
		font-weight: 700;
		font-size: 20px;
		color: #111827;
		text-align: center;
		height: 50px;
		line-height: 50px;
		background: rgba(0,0,0,0.001);
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
		// box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
	  }
	  .ts-box {
		  margin: 16px auto;
		  width: 347px;
		  background: #fff;
		  // box-shadow: 0px 1px 2px 01px rgba(0,0,0,0.05);
      border: 1px solid rgba(0, 0, 0, 0.05);
		  border-radius: 16px;
		  padding: 10px;
		  box-sizing: border-box;
		  display: flex;
		  line-height: initial;
		  .ts-icon {
			  flex-shrink: 0;
			  margin-right: 5px;
			  width: 20px;
			  height: 20px;
			  background: #4F46E5;
			  text-align: center;
			  line-height: 20px;
			  color: #fff;
			  font-weight: bold;
			  border-radius: 50%;
		  }
	  }
	  .topBox {
		  flex-direction: column;
      align-items: center;
		  padding: 10px;
		  font-size: 15px;
	  }
	  .topBox1 {
		  display: flex;
		  align-items: center;
		  justify-content: center;
		  flex-wrap: wrap;
		  gap: 5px;
		  margin-bottom: 3px;
	  }
	  .ts-msg2{
	      font-size: 15px;
	    color: #666666;
	    text-align: left;
	    padding-top: 10px;
	    padding-bottom: 25px;
	  }
	  .ts-box1 {
		  width: 347px;
		  margin: 0 auto;
		  background: #FFFFFF rgba(0,0,0,0.001);
		  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
		  border-radius: 16px;
		  padding: 5px;
		  box-sizing: border-box;
		  text-align: left;
		  line-height: initial;
	  }
  }
.preview-area {
   margin-top: 16px;
  margin-bottom: 10px; /* 增加底部间距 */
}

.preview-title {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #666;
}

.preview-content {
  display: flex;
  justify-content: center;
  background-color: #fff;
  padding: 10px;
  box-sizing: border-box;
  min-height: 80px; /* 设置最小高度，确保图片加载前有足够空间 */
}

.preview-char {
  max-width: 90%;
  max-height: 100%;
}
  .button-container {
    width: 100px;
  margin: 20px auto;
}
  .preview-image {
    margin-top: 20px;
  max-width: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
  }
</style>
